import { Flex, FlexProps } from "@chakra-ui/react";
import { NewHireJourney } from "models/v2/newHireJourney";
import { BuddyInfo, ManagerInfo, PeopleTeamContactInfo } from "./SupportTeamFields";

interface NewHireSupportTeamProps extends FlexProps {
  size: "sm" | "md";
  newHireJourney: NewHireJourney;
}

export default function NewHireSupportTeam({ newHireJourney, size, ...rest }: NewHireSupportTeamProps) {
  return (
    <Flex display="inline-flex" gap="4" {...rest}>
      <ManagerInfo newHireJourney={newHireJourney} size={size} />
      <BuddyInfo newHireJourney={newHireJourney} size={size} />
      <PeopleTeamContactInfo newHireJourney={newHireJourney} size={size} />
    </Flex>
  );
}
